import { _ as __rest, a as __assign } from './tslib.es6-21effb23.js';
import * as React from 'react';

var CheckIcon = function (_a) {
    var _b = _a.fillColor, fillColor = _b === void 0 ? "currentColor" : _b, props = __rest(_a, ["fillColor"]);
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.4264 4.39052C24.9471 4.91122 24.9471 5.75544 24.4264 6.27614L10.2041 20.4984C9.68345 21.0191 8.83923 21.0191 8.31853 20.4984L1.20742 13.3873C0.68672 12.8666 0.68672 12.0223 1.20742 11.5016C1.72812 10.9809 2.57234 10.9809 3.09304 11.5016L9.26134 17.6699L22.5408 4.39052C23.0615 3.86983 23.9057 3.86983 24.4264 4.39052Z", fill: fillColor })));
};

export { CheckIcon as C };
